import { render, staticRenderFns } from "./wtUserAssetsActions.component.vue?vue&type=template&id=54bd6ac6&scoped=true&"
import script from "./wtUserAssetsActions.component.vue?vue&type=script&lang=js&"
export * from "./wtUserAssetsActions.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54bd6ac6",
  null
  
)

export default component.exports